var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Menu-container"},_vm._l((_vm.MenuData),function(item){return _c('router-link',{key:item.id,staticClass:"Menu-item",attrs:{"exact":item.exact,"to":{ name: item.text },"active-class":"active","exact-active-class":""}},[_c('Icon',{attrs:{"type":item.type}}),_c('label',[_vm._v(_vm._s(item.text))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }